import React from 'react';
import Sidebar from '../../../common_components/Sidebar';
import SectionCard from '../../../common_components/SectionCard';
import '../../../styles/Home.scss';
import CmykSmall from '../../../common_components/design_components/CmykSmall';
import CmykVert from '../../../common_components/design_components/CmykVert';
import Mark from '../../../common_components/design_components/Mark';

const HomeDesktop = () => {
  return (
    <div className="homepage">
      <div className="small-cmyk-bar">
        <CmykSmall />
      </div>
      <div className="layout-container">
      <Sidebar />
        <div className="sections"> 
          <div className="top-row">
            <SectionCard
              title="ILLUSTRATIONS"
              description="Inspired by nature and history, my illustrations blend tradition and technology. Whether using paper or digital tools, the process is deeply absorbing—a meditative escape."
              className="illustrations"
              to="/illustrations" 
            />
            <SectionCard
              title="CONTACT"
              description="Drop me a line! Have an idea or question? Let's make something great together—shoot me a note and let's chat!"
              className="contact"
              to="/contact"
            />
          </div>     
          {/* Print Projects */}
          <SectionCard
            title="PRINT PROJECTS"
            description="From business cards to billboards, I’ve designed a wide range of print materials to meet diverse needs. My portfolio includes brochures, flyers, posters, stickers, magazines, event programs, signage, and large-format projects like banners and billboards. Each project, regardless of scale, receives the same careful attention to detail and focus on clear communication."
            className="print-projects"
            to="/print-projects"
          />
          {/* Digital Projects */}
          <SectionCard
            title="DIGITAL PROJECTS"
            description="I’ve done it all—digital ads, social media posts and campaigns, web design, web development, and full webmaster responsibilities. My experience includes creating engaging visuals for online marketing, building and managing websites, optimizing user experiences, and troubleshooting technical issues to ensure seamless functionality. From initial concepts to final implementation, I combine creativity, technical expertise, and a problem-solving mindset to deliver effective and polished results across digital platforms."
            className="digital-projects"
            to="/digital-projects"
          />
        </div>
      </div>
      <div className="cmyk-vert-container">
        <CmykVert />
      </div>
       {/* Registration Marks */}
      <div className="registration-mark top-left">
        <Mark />
      </div>
      <div className="registration-mark top-right">
        <Mark />
      </div>
      <div className="registration-mark bottom-left">
        <Mark />
      </div>
      <div className="registration-mark bottom-right">
        <Mark />
      </div>
    </div>
  );
};

export default HomeDesktop;
